import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from '../static/styles/EditProfile.module.css';
import { useEffect } from 'react';

const Thankyou = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    useEffect(() => {
        document.title = `${t('thankyou')} | Jazz ESL`;
    }, [t]);

    return (
        <div className={styles.editProfile}>
            <h3 style={{textAlign: 'center', color: '#E3931B'}}>{t('thankyou').toUpperCase()}</h3>
            <p style={{textAlign:'center', whiteSpace: 'pre-line'}}>{t('redemption_succ')}</p>
            <button
                className={styles.saveButton}
                onClick={() => {navigate('/');}}
            >
                Home
            </button>
        </div>
    );
};

export default Thankyou;